import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Shield } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'rooam_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // Don't show on overlay routes (OBS browser source)
  const isOverlayRoute = location.pathname.startsWith('/overlay/');

  useEffect(() => {
    if (isOverlayRoute) return;
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [isOverlayRoute]);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto bg-zinc-900 border border-zinc-700 rounded-xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="h-5 w-5 text-cyan-400 shrink-0 mt-0.5 sm:mt-0 hidden sm:block" />
        <div className="flex-1 text-sm text-zinc-400 leading-relaxed">
          We use cookies to enhance your experience, analyze site traffic, and serve relevant content. By continuing to use Rooam Sports, you agree to our use of cookies. Read our{' '}
          <Link to="/legal#privacy-policy" className="text-cyan-400 hover:underline font-medium">
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link to="/legal#coppa" className="text-cyan-400 hover:underline font-medium">
            Youth Data Protection (COPPA)
          </Link>{' '}
          policy for more details.
        </div>
        <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">
          <button
            onClick={decline}
            className="flex-1 sm:flex-none px-4 py-2 text-sm text-zinc-400 hover:text-white border border-zinc-600 rounded-lg transition-colors"
            data-testid="cookie-decline-btn"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="flex-1 sm:flex-none px-5 py-2 text-sm font-semibold text-white bg-cyan-600 hover:bg-cyan-500 rounded-lg transition-colors"
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
        <button
          onClick={decline}
          className="absolute top-3 right-3 sm:hidden text-zinc-500 hover:text-white"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
